import PrivacyPolicy from '../components/PrivacyPolicy'

function Home({ t, lang }) {
    return (
    <main className="page-container bg-custom">
        <div className='container text-center'>
            <h1 className='page-title'>{t("nav_privacy_policy").toUpperCase()}</h1>
            <PrivacyPolicy t={t} lang={lang} />
        </div>
    </main>
    );
}

export default Home;